import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=71d939cb&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d939cb')) {
      api.createRecord('71d939cb', component.options)
    } else {
      api.reload('71d939cb', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=71d939cb&", function () {
      api.rerender('71d939cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25WzVhz75a9O0/JS/comp/pricelist.vue"
export default component.exports